import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import './actions-btn.scss';
// import DialogPanel from '../../Components/dialog-panel/dialog-panel';

/**
 * @typedef {'small' | 'medium' | 'large'} SizeType - Size choices for the Demo component.
 */

/**
 * Component to demonstrate different sizes, appearances, and popup options.
 * @param {Object} props
 * @param {SizeType} props.size
 * @returns {JSX.Element}
 */

function ActionButton({ className, onClick, children, disabled, size }) {
  const sizeProperties = {
    small: 'small',
    medium: 'medium',
    large: 'large',
  };
  const sizeProps = sizeProperties[size];
  const buttonContent = useRef(null);
  const [buttonWidth, setButtonWidth] = useState('1.806vw');
  const getButtonWidth = () => {
    setButtonWidth(buttonContent.current.getBoundingClientRect().width + 2);
  };

  return (
    <button
      type="button"
      className={`actions-button ${sizeProps} ${className}`}
      onClick={onClick}
      disabled={disabled}
      onMouseOver={getButtonWidth}
      onFocus={getButtonWidth}
      onMouseOut={() => setButtonWidth('1.806vw')}
      onBlur={() => setButtonWidth('1.806vw')}
      style={{ width: buttonWidth }}
    >
      <span className="btn-content" ref={buttonContent}>
        {children}
      </span>
    </button>
  );
}

ActionButton.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node,
  disabled: PropTypes.bool,
  size: PropTypes.string,
};

ActionButton.defaultProps = {
  className: '',
  onClick: () => {},
  children: {},
  disabled: false,
  size: '',
};

export default ActionButton;
